import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const uid = () => Math.random().toString(36).slice(2, 10);
const now = () => new Date().toISOString();
const dias = (n) => new Date(Date.now() + n * 86400000).toISOString();

export const calcularCorUrgencia = (dataAbertura, dataPrazo) => {
  const total = new Date(dataPrazo) - new Date(dataAbertura);
  const restante = new Date(dataPrazo) - new Date();
  if (restante <= 0) return 'vermelho';
  const pct = restante / total;
  if (pct > 0.5) return 'verde';
  if (pct > 0.25) return 'amarelo';
  return 'laranja';
};

// Módulos disponíveis no sistema
export const TODOS_MODULOS = ['dashboard', 'chat', 'crm', 'clientes', 'contratos', 'acompanhamento', 'midias', 'trafego', 'comercial', 'chamados', 'projetos', 'reunioes', 'financeiro', 'admin', 'conta'];

// ─── Usuários reais da Legacy ──────────────────────────────────────────────
const SEED_USUARIOS = [
  { id: 'u1', nome: 'Julio Maranhao',       email: 'julio@legacy.com.br',   telefone: '', bio: '', nivel_acesso: 1, cargo: 'Administrador',           senha: '12345', ativo: true, ultimo_login: now(),    modulos: TODOS_MODULOS },
  { id: 'u2', nome: 'Flavio Alves',         email: 'flavio@legacy.com.br',  telefone: '', bio: '', nivel_acesso: 2, cargo: 'Gestor de Tráfego',        senha: '12345', ativo: true, ultimo_login: dias(-1), modulos: ['dashboard', 'chat', 'midias', 'trafego', 'chamados', 'reunioes', 'conta'] },
  { id: 'u3', nome: 'Kaylane Maria',        email: 'kaylane@legacy.com.br', telefone: '', bio: '', nivel_acesso: 2, cargo: 'Gestora de Mídias',        senha: '12345', ativo: true, ultimo_login: dias(-1), modulos: ['dashboard', 'chat', 'midias', 'chamados', 'reunioes', 'conta'] },
  { id: 'u4', nome: 'Vitoria Mariana',      email: 'vitoria@legacy.com.br', telefone: '', bio: '', nivel_acesso: 3, cargo: 'Designer',                 senha: '12345', ativo: true, ultimo_login: dias(-2), modulos: ['dashboard', 'chat', 'midias', 'chamados', 'reunioes', 'conta'] },
  { id: 'u5', nome: 'Millena Albuquerque',  email: 'millena@legacy.com.br', telefone: '', bio: '', nivel_acesso: 3, cargo: 'Filmmaker',                senha: '12345', ativo: true, ultimo_login: dias(-2), modulos: ['dashboard', 'chat', 'midias', 'chamados', 'reunioes', 'conta'] },
  { id: 'u6', nome: 'Sophia',               email: 'sophia@legacy.com.br',  telefone: '', bio: '', nivel_acesso: 3, cargo: 'Estagiária Administrativa',senha: '12345', ativo: true, ultimo_login: dias(-3), modulos: ['dashboard', 'chat', 'chamados', 'reunioes', 'conta'] },
];

// ─── Clientes ──────────────────────────────────────────────────────────────
const SEED_CLIENTES = [
  { id: 'c1',  razao_social: 'Horizonte Coworking',    nome_fantasia: 'Horizonte Coworking',    slug: 'horizonte-coworking',  segmento: 'Coworking',      status: 'ativo', email: 'contato@horizontecoworking.com.br', telefone: '', instagram: '@horizontecoworking',  criado_em: dias(-90) },
  { id: 'c2',  razao_social: 'Viela Bar',              nome_fantasia: 'Viela Bar',              slug: 'viela-bar',            segmento: 'Gastronomia',    status: 'ativo', email: 'contato@vielabar.com.br',           telefone: '', instagram: '@vielabar',           criado_em: dias(-80) },
  { id: 'c3',  razao_social: 'Viela Coworking',        nome_fantasia: 'Viela Coworking',        slug: 'viela-coworking',      segmento: 'Coworking',      status: 'ativo', email: 'contato@vielacoworking.com.br',     telefone: '', instagram: '@vielacoworking',     criado_em: dias(-80) },
  { id: 'c4',  razao_social: 'LocarPe Rent a Car',     nome_fantasia: 'LocarPe',                slug: 'locare-rent',          segmento: 'Locadora',       status: 'ativo', email: 'contato@locarpe.com.br',            telefone: '', instagram: '@locarpe',            criado_em: dias(-70) },
  { id: 'c5',  razao_social: 'Comfort Locadora',       nome_fantasia: 'Comfort Locadora',       slug: 'comfort-locadora',     segmento: 'Locadora',       status: 'ativo', email: 'contato@comfortlocadora.com.br',    telefone: '', instagram: '@comfortlocadora',   criado_em: dias(-65) },
  { id: 'c6',  razao_social: 'Pernambuco Rent a Car',  nome_fantasia: 'Pernambuco Rent a Car',  slug: 'pernambuco-rent',      segmento: 'Locadora',       status: 'ativo', email: 'contato@pernambucorenta.com.br',    telefone: '', instagram: '@pernambucorent',    criado_em: dias(-60) },
  { id: 'c7',  razao_social: 'BoraMar',                nome_fantasia: 'BoraMar',                slug: 'boramar',              segmento: 'Turismo/Lazer',  status: 'ativo', email: 'contato@boramar.com.br',            telefone: '', instagram: '@boramar',           criado_em: dias(-55) },
  { id: 'c8',  razao_social: 'Easy Porto Hotel',       nome_fantasia: 'Easy Porto Hotel',       slug: 'easy-porto',           segmento: 'Hotelaria',      status: 'ativo', email: 'contato@easyportohotel.com.br',     telefone: '', instagram: '@easyportohotel',   criado_em: dias(-50) },
  { id: 'c9',  razao_social: 'Tecnoforma',             nome_fantasia: 'Tecnoforma',             slug: 'tecnoforma',           segmento: 'Tecnologia',     status: 'ativo', email: 'contato@tecnoforma.com.br',         telefone: '', instagram: '@tecnoforma',        criado_em: dias(-45) },
  { id: 'c10', razao_social: 'Smart Gestão',           nome_fantasia: 'Smart Gestão',           slug: 'smart-gestao',         segmento: 'Consultoria',    status: 'ativo', email: 'contato@smartgestao.com.br',        telefone: '', instagram: '@smartgestao',       criado_em: dias(-40) },
  { id: 'c11', razao_social: 'Dra. Mayara Maia',       nome_fantasia: 'Dra. Mayara Maia',       slug: 'dra-mayara-maia',      segmento: 'Saúde/Medicina', status: 'ativo', email: 'contato@drmayaramaia.com.br',       telefone: '', instagram: '@dra.mayaramaia',   criado_em: dias(-35) },
  { id: 'c12', razao_social: 'Esteio Assessoria',      nome_fantasia: 'Esteio Assessoria',      slug: 'esteio-assessoria',    segmento: 'Assessoria',     status: 'ativo', email: 'contato@esteioassessoria.com.br',   telefone: '', instagram: '@esteioassessoria', criado_em: dias(-30) },
];

// ─── Mídias — Produção ─────────────────────────────────────────────────────
const SEED_PRODUCOES = [];

// ─── Planejamentos ─────────────────────────────────────────────────────────
const SEED_PLANEJAMENTOS_SEMESTRAIS = [
  { id: 'ps1', cliente_id: 'c1', semestre: 1, ano: 2025, objetivos: 'Aumentar reconhecimento de marca e ocupação do espaço', temas: ['Lifestyle', 'Networking', 'Cases de sucesso', 'Infraestrutura'], quantidade_posts_semana: 5, plataformas: ['instagram', 'linkedin'], responsavel_id: 'u3', criado_em: dias(-60) },
  { id: 'ps2', cliente_id: 'c2', semestre: 1, ano: 2025, objetivos: 'Atrair público jovem e aumentar reservas no período noturno', temas: ['Gastronomia', 'Eventos', 'Promoções', 'Ambiente'], quantidade_posts_semana: 7, plataformas: ['instagram', 'tiktok'], responsavel_id: 'u3', criado_em: dias(-60) },
];

const SEED_PLANEJAMENTOS_MENSAIS = [
  { id: 'pm1', cliente_id: 'c1', mes: 7, ano: 2025, grade: [
    { semana: 1, dias: [{ dia: 'Seg', tipo: 'post_feed', tema: 'Apresentação do espaço', status: 'pendente' }, { dia: 'Qua', tipo: 'story', tema: 'Depoimento de cliente', status: 'pendente' }, { dia: 'Sex', tipo: 'reel', tema: 'Tour pelo coworking', status: 'pendente' }] },
    { semana: 2, dias: [{ dia: 'Ter', tipo: 'post_feed', tema: 'Dica de produtividade', status: 'pendente' }, { dia: 'Qui', tipo: 'carrossel', tema: 'Planos e preços', status: 'pendente' }] },
  ], observacoes: 'Mês de julho com foco em conversão para plano mensal', responsavel_id: 'u3', criado_em: dias(-10) },
];

// ─── Demandas Extras ───────────────────────────────────────────────────────
const SEED_DEMANDAS_EXTRAS = [
  { id: 'de1', cliente_id: 'c2',  titulo: 'Post especial dia dos namorados', descricao: 'Post especial para o dia dos namorados com desconto para casais', solicitante: 'Viela Bar',       status: 'em_andamento', prioridade: 'alta',  responsavel_id: 'u3', criado_em: dias(-3) },
  { id: 'de2', cliente_id: 'c8',  titulo: 'Story check-in criativo',         descricao: 'Story animado para os hóspedes fazerem check-in',                solicitante: 'Easy Porto Hotel', status: 'pendente',      prioridade: 'media', responsavel_id: null, criado_em: dias(-1) },
  { id: 'de3', cliente_id: 'c11', titulo: 'Repost de artigo científico',     descricao: 'Adaptar artigo sobre botox para linguagem das redes sociais',    solicitante: 'Dra. Mayara Maia', status: 'concluido',     prioridade: 'baixa', responsavel_id: 'u4', criado_em: dias(-7) },
];

// ─── Captações ─────────────────────────────────────────────────────────────
const SEED_CAPTACOES = [
  { id: 'cap1', cliente_id: 'c1', data_agendada: dias(3),  local: 'Horizonte Coworking — Av. Principal, 100', tipo_conteudo: ['fotos', 'videos', 'reels'], quantidade_estimada: 30, briefing: 'Captação do espaço e pessoas trabalhando. Tom moderno e profissional.', status: 'agendado',  responsavel_filmmaker: 'u5', criado_em: dias(-2) },
  { id: 'cap2', cliente_id: 'c4', data_agendada: dias(7),  local: 'LocarPe — Pátio da frota',               tipo_conteudo: ['fotos', 'videos'],          quantidade_estimada: 20, briefing: 'Fotos dos veículos novos. Fundo limpo, luz natural.',                status: 'agendado',  responsavel_filmmaker: 'u5', criado_em: dias(-1) },
  { id: 'cap3', cliente_id: 'c2', data_agendada: dias(-3), local: 'Viela Bar — Área interna e deck',        tipo_conteudo: ['fotos', 'reels'],           quantidade_estimada: 40, briefing: 'Captação do ambiente, drinks e pratos. Tom quente e descontraído.',   status: 'realizado', responsavel_filmmaker: 'u5', criado_em: dias(-10) },
];

// ─── Chamados ──────────────────────────────────────────────────────────────
const SEED_CHAMADOS = [];

// ─── CRM — Leads ───────────────────────────────────────────────────────────
const SEED_LEADS = [];

// ─── Campanhas de Tráfego ──────────────────────────────────────────────────
const SEED_CAMPANHAS = [];

// ─── Financeiro ────────────────────────────────────────────────────────────
const SEED_TRANSACOES = [];

// Recorrentes mensais — receitas e despesas fixas
const SEED_RECORRENTES = []; // dados reais ficam no banco (app_dados), não no código

// Dívidas antigas — amortização mensal
const SEED_DIVIDAS = []; // dados reais ficam no banco (app_dados), não no código

// ─── Acompanhamento Comercial ──────────────────────────────────────────────
const SEED_METAS = [];

const SEED_FOLLOWUPS = [];

const SEED_INTERACOES = [];

// ─── Contratos ─────────────────────────────────────────────────────────────
const SEED_CONTRATOS = [];

// ─── Reuniões ──────────────────────────────────────────────────────────────
const SEED_REUNIOES = [];

// ─── Store principal ────────────────────────────────────────────────────────
const useAppStore = create(
  persist(
    (set, get) => ({
      usuario: null,
      usuarioLogado: false,
      tema: 'escuro',
      setTema: (t) => { set({ tema: t }); document.documentElement.setAttribute('data-tema', t); },

      // ─── Online status ────────────────────────────────────────────
      pingOnline: (id) => set(s => ({
        usuarios: s.usuarios.map(u => u.id === id ? { ...u, online_em: new Date().toISOString() } : u),
        usuario: s.usuario?.id === id ? { ...s.usuario, online_em: new Date().toISOString() } : s.usuario,
      })),

      login: (usuario, senha) => {
        const userList = get().usuarios;
        // Login pelo primeiro nome (case insensitive)
        const primeiroNome = (n) => n.trim().split(' ')[0].toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
        const u = userList.find(u => primeiroNome(u.nome) === primeiroNome(usuario));
        if (!u || !u.ativo) return false;
        if (u.senha !== senha) return false;
        const modulos = u.nivel_acesso <= 1 ? TODOS_MODULOS : u.modulos;
        set({ usuario: { ...u, modulos }, usuarioLogado: true });
        get().updateUsuario(u.id, { ultimo_login: now() });
        return true;
      },

      setUsuarioLogado: (usuarioApi) => {
        const modulosDaApi = usuarioApi.permissoes
          ? usuarioApi.permissoes.filter(p => p.pode_visualizar).map(p => p.modulo)
          : (usuarioApi.modulos || []);
        const modulos = usuarioApi.nivel_acesso <= 1 ? TODOS_MODULOS : modulosDaApi;
        set({ usuario: { ...usuarioApi, modulos }, usuarioLogado: true });
      },

      logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        set({ usuario: null, usuarioLogado: false });
      },

      // ─── Usuários ────────────────────────────────────────────────
      usuarios: SEED_USUARIOS,
      addUsuario: (dados) => set(s => ({ usuarios: [...s.usuarios, { id: uid(), ativo: true, ultimo_login: null, criado_em: now(), senha: '12345', telefone: '', bio: '', ...dados }] })),
      updateUsuario: (id, dados) => set(s => {
        const atualizados = s.usuarios.map(u => u.id === id ? { ...u, ...dados } : u);
        // Manter sessão sincronizada se o usuário logado for o mesmo
        const novoUsuario = s.usuario?.id === id ? { ...s.usuario, ...dados } : s.usuario;
        return { usuarios: atualizados, usuario: novoUsuario };
      }),
      updateSenha: (id, senhaAtual, novaSenha) => {
        const u = get().usuarios.find(u => u.id === id);
        if (!u || u.senha !== senhaAtual) return false;
        get().updateUsuario(id, { senha: novaSenha });
        return true;
      },

      // ─── Clientes ────────────────────────────────────────────────
      clientes: SEED_CLIENTES,
      addCliente: (dados) => set(s => ({ clientes: [{ id: uid(), status: 'ativo', criado_em: now(), slug: dados.razao_social?.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, ''), ...dados }, ...s.clientes] })),
      updateCliente: (id, dados) => set(s => ({ clientes: s.clientes.map(c => c.id === id ? { ...c, ...dados } : c) })),
      deleteCliente: (id) => set(s => ({ clientes: s.clientes.filter(c => c.id !== id) })),

      // ─── Contratos ───────────────────────────────────────────────
      contratos: SEED_CONTRATOS,
      addContrato: (dados) => set(s => ({ contratos: [{ id: uid(), status: 'rascunho', criado_em: now(), servicos: [], ...dados }, ...s.contratos] })),
      updateContrato: (id, dados) => set(s => ({ contratos: s.contratos.map(c => c.id === id ? { ...c, ...dados } : c) })),
      deleteContrato: (id) => set(s => ({ contratos: s.contratos.filter(c => c.id !== id) })),
      ativarContrato: (id) => set(s => ({ contratos: s.contratos.map(c => c.id === id ? { ...c, status: 'ativo', ativado_em: now() } : c) })),

      // ─── Leads / CRM ─────────────────────────────────────────────
      leads: SEED_LEADS,
      interacoes: SEED_INTERACOES,
      addLead: (dados) => set(s => ({ leads: [{ id: uid(), etapa: 'prospeccao', probabilidade: 50, criado_em: now(), ...dados }, ...s.leads] })),
      updateLead: (id, dados) => set(s => ({ leads: s.leads.map(l => l.id === id ? { ...l, ...dados } : l) })),
      moverLead: (id, etapa) => set(s => ({ leads: s.leads.map(l => l.id === id ? { ...l, etapa } : l) })),
      addInteracao: (dados) => set(s => ({ interacoes: [{ id: uid(), criado_em: now(), ...dados }, ...s.interacoes] })),

      // ─── Chamados ────────────────────────────────────────────────
      chamados: SEED_CHAMADOS,
      chamadoAtualizacoes: [],
      addChamado: (dados) => {
        const horasPrazo = dados.prazo_horas || 48;
        const dataAbertura = now();
        const dataPrazo = new Date(Date.now() + horasPrazo * 3600000).toISOString();
        set(s => ({ chamados: [{ id: uid(), status: 'pendente', prioridade: 'media', criado_em: now(), data_abertura: dataAbertura, data_prazo: dataPrazo, ...dados }, ...s.chamados] }));
      },
      updateChamado: (id, dados) => set(s => ({
        chamados: s.chamados.map(c => c.id === id ? { ...c, ...dados, data_conclusao: ['concluido', 'cancelado'].includes(dados.status) ? now() : c.data_conclusao } : c)
      })),
      addAtualizacaoChamado: (chamadoId, texto, statusNovo) => {
        set(s => {
          const novaAtu = { id: uid(), chamado_id: chamadoId, texto, status_novo: statusNovo || null, autor_nome: s.usuario?.nome || 'Sistema', criado_em: now() };
          const chamados = statusNovo ? s.chamados.map(c => c.id === chamadoId ? { ...c, status: statusNovo, data_conclusao: ['concluido', 'cancelado'].includes(statusNovo) ? now() : c.data_conclusao } : c) : s.chamados;
          return { chamadoAtualizacoes: [...s.chamadoAtualizacoes, novaAtu], chamados };
        });
      },

      // ─── Notificações ─────────────────────────────────────────────
      notificacoes: [],
      addNotificacao: (dados) => set(s => ({ notificacoes: [{ id: uid(), lida: false, criado_em: now(), ...dados }, ...s.notificacoes] })),
      marcarLida: (id) => set(s => ({ notificacoes: s.notificacoes.map(n => n.id === id ? { ...n, lida: true } : n) })),
      marcarTodasLidas: (userId) => set(s => ({ notificacoes: s.notificacoes.map(n => n.destinatario_id === userId ? { ...n, lida: true } : n) })),

      // ─── Mídias — Produção ────────────────────────────────────────
      producoes: SEED_PRODUCOES,
      addProducao: (dados) => {
        const usuario = get().usuario;
        const novaId = uid();
        const nova = { id: novaId, status: 'copy', versao: 1, criado_em: now(), criado_por: usuario?.id, checklist: [], etiquetas: [], ...dados };
        set(s => ({ producoes: [nova, ...s.producoes] }));
        if (dados.responsavel_id && dados.responsavel_id !== usuario?.id) {
          get().addNotificacao({
            destinatario_id: dados.responsavel_id,
            tipo: 'producao_atribuida',
            titulo: 'Nova produção atribuída a você',
            mensagem: `"${dados.titulo}" foi atribuída a você por ${usuario?.nome || 'Admin'}`,
            referencia_id: novaId,
            referencia_tipo: 'producao',
          });
        }
      },
      updateProducao: (id, dados) => {
        const usuario = get().usuario;
        const producaoAtual = get().producoes.find(p => p.id === id);
        set(s => ({ producoes: s.producoes.map(p => p.id === id ? { ...p, ...dados } : p) }));
        if (dados.responsavel_id && producaoAtual && dados.responsavel_id !== producaoAtual.responsavel_id && dados.responsavel_id !== usuario?.id) {
          get().addNotificacao({
            destinatario_id: dados.responsavel_id,
            tipo: 'producao_atribuida',
            titulo: 'Produção transferida para você',
            mensagem: `"${producaoAtual.titulo}" foi transferida para você por ${usuario?.nome || 'Admin'}`,
            referencia_id: id,
            referencia_tipo: 'producao',
          });
        }
      },
      deleteProducao: (id) => set(s => ({ producoes: s.producoes.filter(p => p.id !== id) })),
      avancarProducao: (id) => {
        const fluxo = ['copy', 'roteiro', 'criativo', 'captacao', 'apresentacao', 'aguardando_aprovacao', 'agendado', 'publicado'];
        set(s => ({
          producoes: s.producoes.map(p => {
            if (p.id !== id) return p;
            const idx = fluxo.indexOf(p.status);
            const proximo = idx < fluxo.length - 1 ? fluxo[idx + 1] : p.status;
            return { ...p, status: proximo };
          })
        }));
      },

      // ─── Mídias — Planejamentos ────────────────────────────────────
      planejamentos_semestrais: SEED_PLANEJAMENTOS_SEMESTRAIS,
      addPlanejamentoSemestral: (dados) => set(s => ({ planejamentos_semestrais: [{ id: uid(), criado_em: now(), ...dados }, ...s.planejamentos_semestrais] })),
      updatePlanejamentoSemestral: (id, dados) => set(s => ({ planejamentos_semestrais: s.planejamentos_semestrais.map(p => p.id === id ? { ...p, ...dados } : p) })),
      deletePlanejamentoSemestral: (id) => set(s => ({ planejamentos_semestrais: s.planejamentos_semestrais.filter(p => p.id !== id) })),

      planejamentos_mensais: SEED_PLANEJAMENTOS_MENSAIS,
      addPlanejamentoMensal: (dados) => set(s => ({ planejamentos_mensais: [{ id: uid(), criado_em: now(), ...dados }, ...s.planejamentos_mensais] })),
      updatePlanejamentoMensal: (id, dados) => set(s => ({ planejamentos_mensais: s.planejamentos_mensais.map(p => p.id === id ? { ...p, ...dados } : p) })),
      deletePlanejamentoMensal: (id) => set(s => ({ planejamentos_mensais: s.planejamentos_mensais.filter(p => p.id !== id) })),

      // ─── Mídias — Demandas Extras ─────────────────────────────────
      demandas_extras: SEED_DEMANDAS_EXTRAS,
      addDemandaExtra: (dados) => set(s => ({ demandas_extras: [{ id: uid(), status: 'pendente', criado_em: now(), ...dados }, ...s.demandas_extras] })),
      updateDemandaExtra: (id, dados) => set(s => ({ demandas_extras: s.demandas_extras.map(d => d.id === id ? { ...d, ...dados } : d) })),
      deleteDemandaExtra: (id) => set(s => ({ demandas_extras: s.demandas_extras.filter(d => d.id !== id) })),

      // ─── Mídias — Captações ────────────────────────────────────────
      captacoes: SEED_CAPTACOES,
      addCaptacao: (dados) => set(s => ({ captacoes: [{ id: uid(), status: 'agendado', criado_em: now(), ...dados }, ...s.captacoes] })),
      updateCaptacao: (id, dados) => set(s => ({ captacoes: s.captacoes.map(c => c.id === id ? { ...c, ...dados } : c) })),
      deleteCaptacao: (id) => set(s => ({ captacoes: s.captacoes.filter(c => c.id !== id) })),

      // ─── Tráfego ─────────────────────────────────────────────────
      campanhas: SEED_CAMPANHAS,
      addCampanha: (dados) => set(s => ({ campanhas: [{ id: uid(), status: 'planejamento', gasto_realizado: 0, kpis: {}, criado_em: now(), ...dados }, ...s.campanhas] })),
      updateCampanha: (id, dados) => set(s => ({ campanhas: s.campanhas.map(c => c.id === id ? { ...c, ...dados } : c) })),
      deleteCampanha: (id) => set(s => ({ campanhas: s.campanhas.filter(c => c.id !== id) })),

      verbas_trafego: [],
      addVerba: (dados) => set(s => ({ verbas_trafego: [{ id: uid(), criado_em: now(), gasto_google: 0, gasto_meta: 0, ...dados }, ...s.verbas_trafego] })),
      updateVerba: (id, dados) => set(s => ({ verbas_trafego: s.verbas_trafego.map(v => v.id === id ? { ...v, ...dados } : v) })),
      deleteVerba: (id) => set(s => ({ verbas_trafego: s.verbas_trafego.filter(v => v.id !== id) })),

      demandas_trafego: [],
      addDemandaTrafego: (dados) => set(s => ({ demandas_trafego: [{ id: uid(), status: 'pendente', criado_em: now(), ...dados }, ...s.demandas_trafego] })),
      updateDemandaTrafego: (id, dados) => set(s => ({ demandas_trafego: s.demandas_trafego.map(d => d.id === id ? { ...d, ...dados } : d) })),
      deleteDemandaTrafego: (id) => set(s => ({ demandas_trafego: s.demandas_trafego.filter(d => d.id !== id) })),

      reunioes_trafego: [],
      addReuniaoTrafego: (dados) => set(s => ({ reunioes_trafego: [{ id: uid(), status: 'agendada', criado_em: now(), ...dados }, ...s.reunioes_trafego] })),
      updateReuniaoTrafego: (id, dados) => set(s => ({ reunioes_trafego: s.reunioes_trafego.map(r => r.id === id ? { ...r, ...dados } : r) })),
      deleteReuniaoTrafego: (id) => set(s => ({ reunioes_trafego: s.reunioes_trafego.filter(r => r.id !== id) })),

      // ─── Financeiro ──────────────────────────────────────────────
      transacoes: SEED_TRANSACOES,
      addTransacao: (dados) => set(s => ({ transacoes: [{ id: uid(), status: 'pendente', criado_em: now(), ...dados }, ...s.transacoes] })),
      updateTransacao: (id, dados) => set(s => ({ transacoes: s.transacoes.map(t => t.id === id ? { ...t, ...dados } : t) })),
      baixarTransacao: (id) => set(s => ({ transacoes: s.transacoes.map(t => t.id === id ? { ...t, status: 'pago', data_pagamento: now() } : t) })),

      // ─── Recorrentes ─────────────────────────────────────────────
      recorrentes: SEED_RECORRENTES,
      addRecorrente: (dados) => set(s => ({ recorrentes: [...s.recorrentes, { id: uid(), ativo: true, criado_em: now(), ...dados }] })),
      updateRecorrente: (id, dados) => set(s => ({ recorrentes: s.recorrentes.map(r => r.id === id ? { ...r, ...dados } : r) })),
      deleteRecorrente: (id) => set(s => ({ recorrentes: s.recorrentes.filter(r => r.id !== id) })),
      toggleRecorrente: (id) => set(s => ({ recorrentes: s.recorrentes.map(r => r.id === id ? { ...r, ativo: !r.ativo } : r) })),

      // ─── Dívidas ─────────────────────────────────────────────────
      dividas: SEED_DIVIDAS,
      addDivida: (dados) => set(s => ({ dividas: [...s.dividas, { id: uid(), valor_amortizado: 0, parcela_mensal: 0, criado_em: now(), ...dados }] })),
      updateDivida: (id, dados) => set(s => ({ dividas: s.dividas.map(d => d.id === id ? { ...d, ...dados } : d) })),
      deleteDivida: (id) => set(s => ({ dividas: s.dividas.filter(d => d.id !== id) })),
      amortizarDivida: (id, valor) => set(s => ({
        dividas: s.dividas.map(d => d.id === id ? { ...d, valor_amortizado: Math.min(d.valor_amortizado + Number(valor), d.valor_total) } : d),
      })),

      // ─── Acomp. Comercial ─────────────────────────────────────────
      metas: SEED_METAS,
      followups: SEED_FOLLOWUPS,
      addMeta: (dados) => set(s => ({ metas: [{ id: uid(), criado_em: now(), ...dados }, ...s.metas] })),
      updateMeta: (id, dados) => set(s => ({ metas: s.metas.map(m => m.id === id ? { ...m, ...dados } : m) })),
      deleteMeta: (id) => set(s => ({ metas: s.metas.filter(m => m.id !== id) })),
      addFollowup: (dados) => set(s => ({ followups: [{ id: uid(), criado_em: now(), ...dados }, ...s.followups] })),
      deleteFollowup: (id) => set(s => ({ followups: s.followups.filter(f => f.id !== id) })),

      // ─── Chat ────────────────────────────────────────────────────
      chat_mensagens: [],
      enviarMensagemChat: (de_id, para_id, texto) => {
        const msg = { id: uid(), de_id, para_id, texto: texto.trim(), criado_em: now(), lida: false };
        set(s => ({ chat_mensagens: [...s.chat_mensagens, msg] }));
      },
      marcarMensagensLidas: (de_id, para_id) => set(s => ({
        chat_mensagens: s.chat_mensagens.map(m =>
          m.de_id === de_id && m.para_id === para_id ? { ...m, lida: true } : m
        ),
      })),

      // ─── Reuniões ─────────────────────────────────────────────────
      reunioes: SEED_REUNIOES,
      addReuniao: (dados) => {
        const usuario = get().usuario;
        const novaId = uid();
        const participantes = dados.participantes || [];
        const nova = { id: novaId, status: 'agendada', criado_em: now(), criado_por: usuario?.id, ...dados, participantes };
        set(s => ({ reunioes: [nova, ...s.reunioes] }));
        // Notificar participantes (exceto quem criou)
        participantes.filter(pid => pid !== usuario?.id).forEach(pid => {
          get().addNotificacao({
            destinatario_id: pid,
            tipo: 'reuniao_convite',
            titulo: 'Você foi convidado para uma reunião',
            mensagem: `"${dados.titulo}" — ${dados.data} às ${dados.hora}. Criado por ${usuario?.nome || 'Admin'}`,
            referencia_id: novaId,
            referencia_tipo: 'reuniao',
          });
        });
      },
      updateReuniao: (id, dados) => {
        const usuario = get().usuario;
        const reuniaoAtual = get().reunioes.find(r => r.id === id);
        const participantesAntigos = reuniaoAtual?.participantes || [];
        set(s => ({ reunioes: s.reunioes.map(r => r.id === id ? { ...r, ...dados } : r) }));
        // Notificar novos participantes adicionados
        if (dados.participantes) {
          const novos = dados.participantes.filter(pid => !participantesAntigos.includes(pid) && pid !== usuario?.id);
          novos.forEach(pid => {
            get().addNotificacao({
              destinatario_id: pid,
              tipo: 'reuniao_convite',
              titulo: 'Você foi adicionado a uma reunião',
              mensagem: `"${reuniaoAtual?.titulo}" — ${dados.data || reuniaoAtual?.data} às ${dados.hora || reuniaoAtual?.hora}`,
              referencia_id: id,
              referencia_tipo: 'reuniao',
            });
          });
        }
      },
      deleteReuniao: (id) => set(s => ({ reunioes: s.reunioes.filter(r => r.id !== id) })),

      // ─── Helpers ──────────────────────────────────────────────────
      getClienteNome: (id) => get().clientes.find(c => c.id === id)?.razao_social || '—',
      getUsuarioNome: (id) => get().usuarios.find(u => u.id === id)?.nome || '—',
      getClienteBySlug: (slug) => get().clientes.find(c => c.slug === slug) || null,

      // ─── Acompanhamento Comercial ─────────────────────────────────
      metas_comerciais: [],
      addMetaComercial: (dados) => set(s => ({ metas_comerciais: [{ id: uid(), token: uid() + uid() + uid(), ativo: true, criado_em: now(), ...dados }, ...s.metas_comerciais] })),
      updateMetaComercial: (id, dados) => set(s => ({ metas_comerciais: s.metas_comerciais.map(m => m.id === id ? { ...m, ...dados } : m) })),
      deleteMetaComercial: (id) => set(s => ({ metas_comerciais: s.metas_comerciais.filter(m => m.id !== id) })),
      getMetaByToken: (token) => get().metas_comerciais.find(m => m.token === token) || null,

      registros_comerciais: [],
      addRegistroComercial: (dados) => set(s => ({ registros_comerciais: [{ id: uid(), criado_em: now(), ...dados }, ...s.registros_comerciais] })),
      updateRegistroComercial: (id, dados) => set(s => ({ registros_comerciais: s.registros_comerciais.map(r => r.id === id ? { ...r, ...dados } : r) })),
      deleteRegistroComercial: (id) => set(s => ({ registros_comerciais: s.registros_comerciais.filter(r => r.id !== id) })),
    }),
    {
      name: 'legacy-pro-storage-v15',
    }
  )
);

export default useAppStore;
